import React from 'react';

import { ResourceHubItemType } from 'components/FeaturedResources/types';
import KeyTemplatesItem from './KeyTemplatesItem';
import Skeleton from './Skeleton';

import styles from './styles.module.scss';
import { InformationCard } from 'components/CMSModals/informationcard';

type KeyTemplatesProp = {
  keyTemplates?: InformationCard[];
  loaded: boolean;
  title?: string;
};

const KeyTemplates: React.FunctionComponent<KeyTemplatesProp> = ({
  keyTemplates,
  loaded,
  title,
}) => {
  return loaded && keyTemplates ? (
    <React.Fragment>
      {keyTemplates && keyTemplates.length > 0 && (
        <section className={styles.keyTemplates}>
          <h3>{title || 'Member Content - Articles'}</h3>
          <ul>
            {keyTemplates.map((keyTemplate: InformationCard, index: number) => (
              <KeyTemplatesItem
                key={`key-template-${index}`}
                keyTemplate={keyTemplate}
              />
            ))}
          </ul>
        </section>
      )}
    </React.Fragment>
  ) : (
    <Skeleton />
  );
};

export default KeyTemplates;
